var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutUsMiddleman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.23779,
    width: 96,
    height: 96,
    rx: 16,
    fill: "white",
    fillOpacity: 0.2,
    stroke: "url(#paint0_linear_99_1194)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13.2378,
    width: 72,
    height: 72,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3508 61.009C51.186 64.2759 46.8267 64.2646 43.6711 60.9834C40.4414 64.6714 35.7932 64.1445 33 59.9558V61.8003C33 63.6958 34.542 65.2378 36.4375 65.2378H61.562C63.4575 65.2378 64.9993 63.6958 64.9993 61.8003V59.9558C62.1824 64.1814 57.5479 64.6306 54.3508 61.009Z",
    fill: "#583FBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7295 61.5759C40.2022 61.5759 41.4939 60.7114 42.4759 59.4902C40.7022 56.8354 39.8999 53.051 41.9678 50.6184C40.9327 50.2654 39.7183 50.2134 38.7295 50.2134C37.5523 50.2134 36.0552 50.2866 34.9209 50.8552C33.4383 51.5989 32.8841 53.0181 33.0198 54.6709C33.251 57.6135 35.5772 61.5759 38.7295 61.5759Z",
    fill: "#583FBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0791 50.8552C61.9446 50.2866 60.4478 50.2134 59.2703 50.2134C58.2935 50.2134 57.0959 50.2642 56.0691 50.606C58.1514 53.0383 57.3533 56.8442 55.5498 59.5222C56.5291 60.7266 57.811 61.5759 59.2703 61.5759C62.5942 61.5759 64.9995 57.1704 64.9995 54.2002C64.9995 52.2314 63.9553 51.2947 63.0791 50.8552Z",
    fill: "#583FBC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6152 54.2004C42.6152 57.2961 45.4185 61.5759 49.0239 61.5759C52.6289 61.5759 55.4326 57.2966 55.4326 54.2004C55.4326 50.2134 50.9417 50.2134 49.0239 50.2134C47.1062 50.2134 42.6152 50.2134 42.6152 54.2004Z",
    fill: "#583FBC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5623 33.2378H36.4377C34.5422 33.2378 33.0005 34.7798 33.0005 36.6753V38.5198C35.8281 34.2776 40.4646 33.8591 43.6489 37.4666C46.8137 34.1997 51.1731 34.2109 54.3286 37.4922C57.4802 33.8936 62.1404 34.2288 64.9995 38.5198V36.6753C64.9995 34.7798 63.4578 33.2378 61.5623 33.2378Z",
    fill: "#583FBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7292 36.8997C35.4053 36.8997 33 41.3052 33 44.2754C33 46.2441 34.0444 47.1809 34.9207 47.6204C36.0549 48.189 37.5518 48.2622 38.7292 48.2622C39.7068 48.2622 40.9036 48.2114 41.9304 47.8696C39.8484 45.4373 40.6465 41.6313 42.45 38.9534C41.4705 37.749 40.1887 36.8997 38.7292 36.8997Z",
    fill: "#583FBC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2703 36.8997C57.7979 36.8997 56.5061 37.7642 55.5234 38.9854C57.2981 41.6414 58.1001 45.4246 56.0322 47.8572C57.0674 48.2102 58.2815 48.2622 59.2703 48.2622C60.4478 48.2622 61.9446 48.189 63.0791 47.6204C64.5618 46.8767 65.1157 45.4578 64.9802 43.8047C64.749 40.8621 62.4229 36.8997 59.2703 36.8997Z",
    fill: "#583FBC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9761 36.8997C45.3882 36.8997 42.5674 41.1604 42.5674 44.2751C42.5674 48.2622 47.0586 48.2622 48.9761 48.2622C50.8938 48.2622 55.3848 48.2622 55.3848 44.2751C55.385 41.1589 52.5632 36.8997 48.9761 36.8997Z",
    fill: "#583FBC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_1194",
    x1: 1,
    y1: 1.23779,
    x2: 97,
    y2: 97.2378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsMiddleman);
export default __webpack_public_path__ + "static/media/about-us-middleman.db9e71bc359a00c39782e437f28c554a.svg";
export { ForwardRef as ReactComponent };